import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import OptionsMenu from './OptionsMenu';

export default function UserAccountMenu() {

    return (
        <Stack
            direction="row"
            sx={{
                // p: 2,
                gap: 1,
                alignItems: 'center',
                // borderTop: '1px solid',
                // borderColor: 'divider',
                pr: 2
            }}
        >
            {/*<Avatar*/}
            {/*    sizes="small"*/}
            {/*    alt={`${loggedInUser?.firstname}`}*/}
            {/*    src="/static/images/avatar/7.jpg"*/}
            {/*    sx={{ width: 36, height: 36 }}*/}
            {/*/>*/}
            <Box sx={{ mr: 'auto' }}>
                {/* <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: '16px' }}>
                        {loggedInUser?.firstname}
                    </Typography> */}
                {/*<Typography variant="caption" sx={{ color: 'text.secondary' }}>*/}
                {/*    {loggedInUser?.email}*/}
                {/*</Typography>*/}
            </Box>
            <OptionsMenu />
        </Stack>
    );
}
